export class ChangePasswordDto {
    username: string;
    newPassword: string;
    currentPassword: string;
    response: number;
    message: string;
    passwordValidationError: Array<string>;
}